import { useCallback, useMemo } from "react";
import useTracking, { CATCH } from "@insightfulscience/smart-react/useTracking";
import { useRun } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import gotoBillingInfo from "./action";
import useSeats from "./useSeats";

const priceToEntry = ({ subscriptionSize, price, betterOption }) => [
	subscriptionSize,
	{ price, betterOption },
];

const compareDiff = x => (a, b) => Math.abs(x - a) - Math.abs(x - b);
const getSeats = ({ subscriptionSize }) => subscriptionSize;

const getInitialSeats = (initialSeats, priceList) => {
	const defaultSeats = priceList.length > 0 ? getSeats(priceList[0]) : undefined;
	if (!initialSeats) return defaultSeats;
	return priceList.map(getSeats).sort(compareDiff(initialSeats))[0];
};

function useSelectSeatsForm(priceList, planCode, initialSeats) {
	const priceBySeats = useMemo(
		() => new Map(priceList.map(priceToEntry)), // factory
		[priceList],
	);

	const firstSeats = useMemo(
		() => getInitialSeats(initialSeats, priceList), // factory
		[],
	);

	const [goAhead, inProcess] = useTracking(useRun(gotoBillingInfo), CATCH);
	const [seats, priceItem, setSeats] = useSeats(firstSeats, priceBySeats);
	const { price, originSeats } = priceItem;

	const updateSeats = useCallback(
		({ target }) => setSeats(parseInt(target.value, 10)), // callback,
		[setSeats],
	);

	const submitForm = useCallback(
		event => {
			if (event) event.preventDefault();
			goAhead({ seats, planCode, price }, "push");
		}, // callback
		[seats, planCode, price],
	);

	return {
		planCode,
		seats,
		originSeats,
		updateSeats,
		price,
		submitForm,
		inProcess,
	};
}

export default useSelectSeatsForm;
